import { NavLink } from 'react-router-dom';
import { CalendarPlus, ClipboardList, RefreshCw, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CalendarEmptyStateProps {
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

export function CalendarEmptyState({ onRefresh, isRefreshing = false }: CalendarEmptyStateProps) {
  return (
    <div className="pointer-events-none absolute inset-x-3 top-24 z-10 flex justify-center sm:top-28">
      <div className="calendar-empty-state pointer-events-auto max-w-md rounded-lg border bg-background/92 p-4 shadow-xl backdrop-blur-xl sm:p-5">
        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <Sparkles className="h-5 w-5" />
        </div>
        <h2 className="text-base font-semibold">Your timeline is clear.</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Add an activity, sync commitments, or open Unscheduled when you want Fluxiplanner to shape the day.
        </p>
        <div className="mt-4 grid grid-cols-2 gap-2">
          <Button asChild size="sm">
            <NavLink to="/unscheduled">
              <ClipboardList className="mr-2 h-4 w-4" />
              Unscheduled
            </NavLink>
          </Button>
          <Button asChild variant="outline" size="sm">
            <NavLink to="/table">
              <CalendarPlus className="mr-2 h-4 w-4" />
              Activities
            </NavLink>
          </Button>
          {onRefresh && (
            <Button
              className="col-span-2"
              variant="ghost"
              size="sm"
              onClick={onRefresh}
              disabled={isRefreshing}
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh calendar
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
